module.exports = __webpack_public_path__ + "img/AC-Media-2.b279a7ce.png";